module.exports = __webpack_public_path__ + "assets/icons/logo-tpk-8d88.svg";